import { X } from "lucide-react";
import { Input } from "../components/ui/input";
import { TextArea } from "../components/ui/textarea";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import type { SurveyOption, SurveyQuestion } from "../types/defaultTypes";

const SortableOption = ({
  option,
  type,
  checked,
  updateCorrect,
  updateOption,
  removeOption,
  questionId,
  questionType,
  error,
}: {
  option: SurveyOption;
  type: "radio" | "checkbox";
  checked: boolean;
  updateCorrect: (qId: string, type: SurveyQuestion["type"], oId: string) => void;
  updateOption: (qId: string, oId: string, val: string) => void;
  removeOption: (qId: string, oId: string) => void;
  questionId: string;
  questionType: SurveyQuestion["type"];
  error?: string;
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: option.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
      className="flex relative items-center w-full gap-2"
    >
      <Input
        type={type}
        checked={checked}
        onChange={() => updateCorrect(questionId, questionType, option.id)}
        className={`${
          type === "radio" ? "!accent-[#16A34A] !border-[#16A34A]" : "!accent-[#16A34A] !border-[#16A34A]"
        } !w-4 !h-4`}
      />

      <TextArea
        value={option.answer}
        placeholder="Option text"
        wrapperClass="!w-full"
        className="!min-h-[42px] !w-full !h-[44px]"
        onChange={(e) => updateOption(questionId, option.id, e.target.value)}
        error={error}
      />

      <button
        onClick={() => removeOption(questionId, option.id)}
        className="!w-8 !h-8 !shrink-0 flex items-center justify-center rounded-lg bg-red-100 border border-red-500 text-red-500"
      >
        <X className="w-5 h-5" />
      </button>
    </div>
  );
};

export default SortableOption;
